import { Box, Icon, Line, Spinner, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import FeatureCompareTable from 'modules/billing/components/FeatureCompareTable'
import { useDatoPlans } from 'modules/onboarding/components/Pricing/DatoPlansContext'

import PricingFaq from '../../PricingFaq'

const Footer = () => {
  const { datoPlans } = useDatoPlans()

  if (!datoPlans) return <Spinner />

  return (
    <Box gap="s48">
      <Box paddingX="s120" gap="s24" width="full" alignSelf="center">
        <Box gap="s16" alignItems="center">
          <Icon.Large icon="window-user" />
          <Text size="400" weight="medium" color="grey1000">
            {i18n.t('pricing_plans.comparison_table.title')}
          </Text>
          <Text size="300">{i18n.t('pricing_plans.comparison_table.description')}</Text>
          <Line />
        </Box>
        <Box gap="s16">
          {datoPlans.comparisonPlans.map((plan, index) => (
            <FeatureCompareTable plan={plan} key={plan.title} index={index} />
          ))}
        </Box>
      </Box>
      <PricingFaq />
    </Box>
  )
}

export default Footer
